<template>
    <div class="container">
        <el-container>
            <el-header>
                <div class="header-content" style="display: flex; justify-content: space-between; align-items: center; height: 100%;">
                    <div class="header-img">
                        <img src="../assets/img/header-logo.svg">
                    </div>
                    <div class="user mobile-user">
                        <el-dropdown trigger="click" @command="handleCommand">
                            <span class="el-dropdown-link">
                                <el-avatar
                                    src="https://wqianc.com/dashujiaoyu/upload/xcx/index/avatar.png"></el-avatar>
                                <div class="user-name">{{ loginInfo.userName }}</div>
                                <i class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click="changeSecret()" command="a"> 修改密码</el-dropdown-item>
                                <el-dropdown-item command="c">{{ showWebEnterBtn ? '隐藏网页进入教室' : '显示网页进入教室' }}</el-dropdown-item>
                                <el-dropdown-item @click="loginOut()" command="b"> 退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-header>
            <el-main>
                <div class="main-container">
                    <div class="top-title" style="display: flex;justify-content: space-between;align-items: center;">
                        <span>我的直播教室</span>
                        <div class="user pc-user">
                            <el-dropdown trigger="click" @command="handleCommand">
                                <span class="el-dropdown-link">
                                    <el-avatar
                                        src="https://wqianc.com/dashujiaoyu/upload/xcx/index/avatar.png"></el-avatar>
                                    <div class="user-name">{{ loginInfo.userName }}</div>
                                    <i class="el-icon-arrow-down"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click="changeSecret()" command="a"> 修改密码</el-dropdown-item>
                                    <el-dropdown-item command="c">{{ showWebEnterBtn ? '隐藏网页进入教室' : '显示网页进入教室' }}</el-dropdown-item>
                                    <el-dropdown-item @click="loginOut()" command="b"> 退出</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <!-- <el-button type="primary" size="small" @click="loginOut">退出登录</el-button> -->
                    </div>
                    <div class="top-notice">
                        使用说明：进入前先确认直播间信息，避免进错直播间；进入前请先测试声音；无特殊情况优先使用客户端直播；点击“电脑-进入教室”无反应时请先检查是否已下载并安装客户端。
                    </div>
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClickItem">
                        <el-tab-pane :label="item.name" :name="item.name" v-for="item in typeList" :key="item.role">
                            <div class="course-list">
                                <div class="list-item" v-for="item in liveList">
                                    <div class="left-box">
                                        <div class="left-box-video-play">
                                            <img src="../assets/img/video-play.svg">
                                        </div>
                                        <div class="left-box-title">
                                            <div class="left-box-top-title">
                                                {{ item.title }}
                                            </div>
                                            <div class="teacher-class">
                                                主讲老师：{{ item.
                                                    speaker }}
                                            </div>
                                            <div class="teacher-class">
                                                直播间ID：{{ item.room_id || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-box">
                                        <div class="right-box-item">
                                            <el-button type="info" size="small"
                                                @click="goBackLive(item)">回放管理</el-button>
                                        </div> 
                                        <div class="right-box-item">
                                            <el-button type="success" size="small"
                                                @click="goRoomApp(item)">电脑-进入教室</el-button>
                                        </div>
                                        <div class="right-box-item">
                                            <el-button type="success" size="small"
                                                @click="goRoomIpid(item)">平板-进入教室</el-button>
                                        </div>
                                        <div class="right-box-item">
                                            <el-button type="success" size="small"
                                                @click="handleCopyCode(item)">复制{{ role === 1 ? '老师' : '助教' }}参加码</el-button>
                                        </div>
                                        <div class="right-box-item" v-if="showWebEnterBtn || role === 2">
                                            <el-button type="success" size="small"
                                                @click="goRoom(item)">{{ role === 2 ? '网页-助教测试' : '网页-进入教室' }}</el-button>
                                        </div>
                                        <div class="right-box-item" v-if="role === 2">
                                            <el-button type="warning" size="small"
                                                @click="goRoomAsStudent(item)">网页-模拟学生</el-button>
                                        </div>
                                    </div>
                                </div>
                                <el-empty description="暂无直播" v-if="liveList.length === 0"></el-empty> 
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-main>
            <el-footer class="page-footer">
                <div class="footer-inner">
                    <div class="footer-pagination" v-if="liveList.length > 0">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="courseQuery.pageNum" :page-sizes="[1, 5, 10, 20]"
                            :page-size="courseQuery.pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="courseQuery.total">
                        </el-pagination>
                    </div>
                    <div class="footer-box">
                        <span>旺黔诚大树教育</span>
                        <span>0851-85516191</span>
                    </div>
                </div>
            </el-footer>
        </el-container>
        <!-- 回放列表 -->
        <el-dialog title="回放管理" :visible.sync="dialogVisible" width="80%" top="4vh" custom-class="back-live-dialog">
            <div class="table-data">
                <div class="detele-button" v-if="backList.length > 0">
                    <el-popconfirm title="确定要删除所选的回放吗？" @confirm="confirmDeteleAll" @cancel="cancelDeteleAll">
                        <el-button type="danger" :disabled="chooseList.length > 0 ? false : true"
                            slot="reference">批量删除</el-button>
                    </el-popconfirm>
                </div>
                <div class="table-wrapper">
                    <!-- PC端表格 -->
                    <el-table class="back-live-table pc-table" :data="backList" border
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column fixed prop="name" label="名称">
                        </el-table-column>
                        <el-table-column label="视频ID">
                            <template slot-scope="scope">
                                {{ scope.row.video_id || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="缩略图" width="120">
                            <template slot-scope="scope">
                                <img v-if="scope.row.preface_url" :src="scope.row.preface_url" alt="缩略图"
                                    style="width: 80px;height: 45px;object-fit: cover;border-radius: 4px;" />
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="时长">
                            <template slot-scope="scope">
                                {{ convertSecondsToHms(scope.row.length) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="生成时间">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button @click="handleClickLook(scope.row)" type="text" size="small">查看</el-button>

                                <!-- <el-link :href="scope.row.play_url" target="_blank" type="primary">查看</el-link> -->
                                <span style="margin-left: 10px;margin-right: 10px;">|</span>
                                <el-button type="text" size="small" @click="goEdit(scope.row)">编辑</el-button>
                                <span style="margin-left: 10px;margin-right: 10px;">|</span>
                                <el-popconfirm title="确定要删除这段回放吗？" @confirm="confirmDetele" @cancel="cancelDetele">
                                    <el-button type="text" size="small" slot="reference"
                                        @click="goDetele(scope.row)">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 移动端卡片列表 -->
                    <div class="mobile-list">
                        <div class="mobile-card" v-for="(item, index) in backList" :key="index">
                            <div class="card-header">
                                <el-checkbox v-model="item.checked" @change="handleMobileCheck(item)"></el-checkbox>
                                <span class="card-title">{{ item.name }}</span>
                            </div>
                            <div class="card-body">
                                <div class="card-row">
                                    <span class="label">视频ID：</span>
                                    <span class="value">{{ item.video_id || '-' }}</span>
                                </div>
                                <div class="card-row">
                                    <span class="label">时长：</span>
                                    <span class="value">{{ convertSecondsToHms(item.length) }}</span>
                                </div>
                                <div class="card-row">
                                    <span class="label">生成时间：</span>
                                    <span class="value">{{ item.create_time }}</span>
                                </div>
                                <div class="card-row" v-if="item.preface_url">
                                    <span class="label">缩略图：</span>
                                    <img :src="item.preface_url" class="card-thumb">
                                </div>
                            </div>
                            <div class="card-footer">
                                <el-button size="small" type="primary" plain @click="handleClickLook(item)">查看</el-button>
                                <el-button size="small" type="warning" plain @click="goEdit(item)">编辑</el-button>
                                <el-popconfirm title="确定要删除这段回放吗？" @confirm="confirmDetele" @cancel="cancelDetele">
                                    <el-button size="small" type="danger" plain slot="reference" @click="goDetele(item)">删除</el-button>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                    
                    <el-empty description="暂无回放" v-if="backList.length === 0" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10; background: rgba(255,255,255,0.9);"></el-empty>
                </div>
            </div>
            <div slot="footer" class="back-live-dialog-footer">
                <div class="back-live-dialog-pagination" v-if="backList.length > 0">
                    <el-pagination @size-change="handleSizeClassChange" @current-change="handleCurrentClassChange"
                        :current-page="classQuery.pageNum" :page-sizes="[1, 5, 10, 20]" :page-size="classQuery.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="classQuery.total">
                    </el-pagination>
                </div>
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 修改回放名称 -->
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="30%">
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="课时名称" :rules="[
                    { required: true, message: '课时名称不能为空' }
                ]">
                    <el-input v-model="ruleForm.courseValue"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateCourse('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog :visible.sync="dialogResetPassword" title="修改密码" width="30%">
            <div class="reset-password-box">
                <el-form label-width="auto" style="max-width: 600px">
                    <el-form-item label="手机号">
                        <el-input disabled v-model="loginInfo.phone" />
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input v-model="loginInfo.password" />
                    </el-form-item>
                    <el-form-item label="确认新密码">
                        <el-input v-model="loginInfo.repetPassword" />
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="submitResetPassword">
                        确定
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import customFetch from '../utils/request'

export default {
    data() {
        return {
            liveList: [],
            courseQuery: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            classQuery: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            loginInfo: {
                phone: "",
                password: "",
                repetPassword: "",
                userName:"",
            },
            dialogVisible: false,
            editDialogVisible: false,//修改课时名称
            dialogResetPassword: false,//修改密码

            backList: [],
            courseValue: "",
            ruleForm: {
                courseValue: ""
            },
            room_id: "",//教室id
            session_id: "",//课时id,
            activeName: '主讲',//选中项的名字，//助教,
            role: 1,//默认角色
            typeList: [
                { name: "主讲", role: 1 },
                { name: "助教", role: 2 }
            ],
            chooseList: [],//回放选中的项
            chooseBackInfo: {},
            showWebEnterBtn: false,
        }
    },
    created() {
        this.initData()
    },
    mounted() {
      this.loginInfo.userName = JSON.parse(localStorage.getItem('token'))?.teacher_name|| ""
    },
    methods: {
        //直播列表
        initData() {
            const userInfo = JSON.parse(localStorage.getItem('token')) || {}
            if (this.role === 1) {
                customFetch(`/myLive/speakerLive?pageNum=${this.courseQuery.pageNum}&pageSize=${this.courseQuery.pageSize}&speaker_phone=${userInfo.phone}`).then(res => {
                    this.liveList = res?.list || []
                    this.courseQuery.total = res?.total || 0
                }).catch((error) => { console.log(error) })
            }
            if (this.role === 2) {
                customFetch(`/myLive/teacherLive?pageNum=${this.courseQuery.pageNum}&pageSize=${this.courseQuery.pageSize}&teacher_phone=${userInfo.phone}`).then(res => {
                    this.liveList = res?.list || []
                    this.courseQuery.total = res?.total || 0
                }).catch((error) => { console.log(error) })
            }
        },
        /**
         * 处理分页大小改变的事件
         *
         * @param val 新的分页大小
         */
        handleSizeChange(val) {
            this.courseQuery.pageSize = val
            this.initData()
        },
        /**
         * 处理当前页码变化的方法
         *
         * @param val 新的页码值
         */
        handleCurrentChange(val) {
            this.courseQuery.pageNum = val
            this.initData()
        },
        //课程回放
        handleSizeClassChange(val) {
            this.classQuery.pageSize = val
            this.getBackList()
        },
        //课程回放
        handleCurrentClassChange(val) {
            this.classQuery.pageNum = val
            this.getBackList()
        },
        //多选
        handleSelectionChange(val) {
            this.chooseList = val
            console.log(val)
        },
        //移动端多选处理
        handleMobileCheck(item) {
            if (item.checked) {
                this.chooseList.push(item)
            } else {
                this.chooseList = this.chooseList.filter(i => i.session_id !== item.session_id)
            }
        },
        //批量删除
        async deleteAll() {
            // let sessionId = this.chooseList.map(item=>item.session_id).jojn(',')
            let sessionIds = this.chooseList.map(item => item.session_id)
            let sessionId = sessionIds.join(',')
            let params = {
                endTime: this.chooseBackInfo?.end_time || '',
                page: this.classQuery.pageNum,
                pageSize: this.classQuery.pageSize,
                phone: this.chooseBackInfo.speaker_phone,
                queryFlag: 'PC',
                roomId: this.chooseBackInfo.room_id,
                sessionId,
                sessionIds,
                startTime: this.chooseBackInfo?.start_time || '',
            }
            let result = await customFetch(`/live/batchDelete`, {
                body: JSON.stringify(params)
            })
            if (result.code === 200) {
                this.getBackList()
                this.$message.success(result.data)
            } else {
                this.$message.error(result.msg)
            }
        },
        //确认删除
        confirmDeteleAll() {
            this.deleteAll()
        },
        //取消删除
        cancelDeteleAll() { },
        //判断当前是pc还是ipad
        isPad() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // Windows平板通常包含"Windows NT"和"Touch"  
            if (/Windows NT/.test(userAgent) && /Touch/.test(userAgent)) {
                return true;
            }

            // iPad用户代理包含"iPad"  
            if (/iPad/i.test(userAgent)) {
                return true;
            }

            // Android平板用户代理通常包含"Android"和"mobile"但不包含"Phone"  
            if (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent) && /Safari/i.test(userAgent)) {
                return true;
            }

            // 其他平板设备可能需要进一步的检测  

            return false;
        },

        //回放列表
        goRoom(item) {
            let teacher, phone;
            if (this.role === 1) {
                teacher = item.speaker
                phone = item.speaker_phone
            } else if (this.role === 2) {
                teacher = item.teacher
                phone = item.teacher_phone
            }
            const url = this.$router.resolve({ path: '/liveRoom', query: { room_id: item.room_id, role: this.role, teacher, phone } })
            //   const url =   this.$router.resolve({ path: '/room', query: { room_id: item.room_id, role: this.role,teacher,phone} })
            window.open(url.href, '_blank')
        },
        //助教以学生身份进入（用于测试）
        goRoomAsStudent(item) {
            let teacher, phone;
            if (this.role === 2) {
                teacher = item.teacher
                phone = item.teacher_phone
            }
            const url = this.$router.resolve({ path: '/liveRoom', query: { room_id: item.room_id, role: 0, teacher, phone } })
            window.open(url.href, '_blank')
        },
        //平板进教室
        goRoomIpid(item) {
            let teacher, phone;
            if (this.role === 1) {
                teacher = item.speaker
                phone = item.speaker_phone
            } else if (this.role === 2) {
                teacher = item.teacher
                phone = item.teacher_phone
            }
            let query = {}
            query.teacher = teacher
            query.phone = phone
            query.room_id = item.room_id
            query.role = this.role
            return this.getsign(query)
        },
        //进入直播
        async goRoomApp(item) {
            let teacher, phone;
            if (this.role === 1) {
                teacher = item.speaker
                phone = item.speaker_phone
            } else if (this.role === 2) {
                teacher = item.teacher
                phone = item.teacher_phone
            }
            let result = await customFetch(`/teacher/detail?name=${teacher}&phone=${phone}`)
            let params = {
                room_id: item.room_id,
                user_avatar: decodeURIComponent(result.list[0]?.picture[0].url),
                user_name: decodeURIComponent(teacher),
                user_number: phone,
                user_role: this.role,
            }
            customFetch(`/live/createSign`, {
                method: 'POST',
                body: JSON.stringify(params)
            }).then(res => {
                if (res.code === 200) {
                    const web_url = `https://e37357257.at.baijiayun.com/web/room/enter?room_id=${params.room_id}&user_number=${params.user_number}&user_name=${encodeURIComponent(params.user_name)}&user_role=${params.user_role}&user_avatar=${encodeURIComponent(params.user_avatar)}&sign=${res.data}`
                    const client_url = 'baijiacloud://urlpath=' + encodeURIComponent(web_url) + '&token=token&ts=ts'
                    window.open(client_url, '_blank')
                }
            }).catch((error) => { console.log(error) })
        },
        goBackLive(item) {
            this.chooseBackInfo = item
            this.room_id = item.room_id
            this.dialogVisible = true
            this.getBackList()
        },
        //如果是ipad，生成签名
        async getsign(query) {
            let result = await customFetch(`/teacher/detail?name=${query.teacher}&phone=${query.phone}`)
            this.user_avatar = decodeURIComponent(result.list[0]?.picture[0].url)
            let params = {
                room_id: query.room_id,
                // user_avatar: decodeURIComponent(result.list[0]?.picture[0].url),
                user_avatar: 'https://wqianc.com/dashujiaoyu/upload/xcx/index/avatar.png',
                user_name: decodeURIComponent(query.teacher),
                user_number: query.phone,
                user_role: query.role,
            }
            query.user_avatar = params.user_avatar
            console.log(params, '生成签名参数')
            customFetch(`/live/createSign`, {
                method: 'POST',
                body: JSON.stringify(params)
            }).then(res => {
                if (res.code === 200) {
                    this.sign = res.data
                    this.getAppUrl(this.sign, query)
                    //    this.getAppUrl(this.sign,query)
                }
            }).catch((error) => { console.log(error) })
        },
        //生成平板app链接
        getAppUrl(sign, query) {
            var params = {};
            // 通过 sign 进入
            params.roomId = query.room_id;
            params.userNumber = query.phone;
            params.userName = query.teacher;
            params.userType = query.role;
            // params.userAvatar = query.user_avatar;
            params.userAvatar = 'https://wqianc.com/dashujiaoyu/upload/xcx/index/avatar.png';
            // 签名计算参数参考直播进教室签名计算文档，参数名一般使用下划线格式
            params.sign = sign;
            console.log(params, '平板参数')
            //如果为分组直播，请传入分组号，非分组直播则不用传此参数
            // params.group_id = query.group_id;
            // 如果您拥有专属域名，需要传入专属域名，没有则不用传值，不参与签名计算
            params.privateDomain = 'e37357257';
            // 教室类型，不传默认大班课，班级类型参考服务端班级类型，不参与签名计算
            params.classType = 2;
            // 云端课堂 app
            //创建a标签
            let a = document.createElement('a');
            a.href = 'bjhlliveapp://room.join?' + $.param(params);
            //  a.target = '_blank';
            a.click();
            //  return window.open('bjhlliveapp://room.join?' + $.param(params))
        },
        //获取回放列表
        getBackList() {
            let params = {
                roomId: this.room_id,
                page: this.classQuery.pageNum,
                pageSize: this.classQuery.pageSize,
                queryFlag: 'PC',
            }
            customFetch(`/live/getList`, { body: JSON.stringify(params) }).then(res => {
                if (res.code === 0) {
                    this.backList = res.data.list
                    this.classQuery.total = res.data.total
                }
            }).catch((error) => { console.log(error) })
        },
        goEdit(item) {
            this.ruleForm.courseValue = item.name
            this.room_id = item.room_id
            this.session_id = item.session_id
            this.editDialogVisible = true
        },
        /**
         * 删除某个元素
         *
         * @param item 要删除的元素对象
         */
        goDetele(item) {
            this.room_id = item.room_id
            this.session_id = item.session_id
        },
        confirmDetele() {
            try {
                customFetch('/live/delete?room_id=' + this.room_id + '&session_id=' + this.session_id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getBackList()
                    }
                })
            } catch (error) {

            }
        },
        cancelDetele() {
            console.log('取消删除')
        },
        updateCourse(formName) {
            if (this.ruleForm.courseValue === '') {
                return this.$message.error('课时名称不能为空')
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    customFetch(`/live/update?name=${this.ruleForm.courseValue}&room_id=${this.room_id}&session_id=${this.session_id}`).then(res => {
                        if (res.code === 0) {
                            this.editDialogVisible = false
                            this.$message.success('修改成功')
                            this.getBackList()
                        }
                    }).catch((error) => { console.log(error) })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        convertSecondsToHms(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
        },
        handleClickItem(tab, event) {
            if (tab.name === '主讲') {
                this.role = 1
            } else if (tab.name === '助教') {
                this.role = 2
            }
            this.initData()
        },
        //查看回放
        handleClickLook(item) {
            const url = this.$router.resolve({
                path: '/backLive', query: { play_url: item.play_url }
            })
            window.open(url.href, '_blank')
            // this.$router.push({ path: '/backLive', query: { play_url: item.play_url } })
            // window.parent.location.href = item.play_url
            // window.location.href = item.play_url
        },
        //退出登录
        loginOut() {
            localStorage.removeItem('token')
            this.$router.push('/login')
        },
        handleCommand(command) {
            if (command === 'a') {
                this.changeSecret()
            } else if (command === 'b') {
                this.loginOut()
            } else if (command === 'c') {
                this.toggleWebEnterButton()
            }
        },
        toggleWebEnterButton() {
            this.showWebEnterBtn = !this.showWebEnterBtn
            this.$message.success(this.showWebEnterBtn ? '已显示网页进入教室按钮' : '已隐藏网页进入教室按钮')
        },
        changeSecret() {
            console.log('修改密码')
            this.dialogResetPassword = true
            let userInfo = JSON.parse(localStorage.getItem('token')) || {}

            this.loginInfo.phone = userInfo.phone

        },
        closeDialog() {
            this.dialogResetPassword = false
        },
        //重置密码
        //复制参加码
        handleCopyCode(item) {
            let code = '';
            let label = '';
            
            // 根据身份判断：1为主讲老师，2为助教
            if (this.role === 1) {
                code = item.teacher_code;
                label = '老师参加码';
            } else if (this.role === 2) {
                code = item.admin_code;
                label = '助教参加码';
            }

            if (!code) {
                this.$message.error(`未获取到${label}`);
                return;
            }

            // 使用原生方式复制到剪贴板，兼容性更好
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.value = code;
            document.body.appendChild(input);
            input.select();
            
            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    this.$message({
                        message: `${label}复制成功: ${code}`,
                        type: 'success',
                        duration: 6000
                    });
                } else {
                    this.$message.error(`${label}复制失败，请手动复制: ${code}`);
                }
            } catch (err) {
                this.$message.error(`${label}复制失败，请手动复制: ${code}`);
            } finally {
                document.body.removeChild(input);
            }
        },
        submitResetPassword() {
            let userInfo = JSON.parse(localStorage.getItem('token')) || {}
            if (this.loginInfo.password !== this.loginInfo.repetPassword) {
                this.$message.error('两次密码不一致');
                return;
            }
            let data = {
                phone: this.loginInfo.phone,
                password: userInfo.password,//旧密码
                newPwd: this.loginInfo.password,//新密码
            }
            customFetch('/userPermittion/resetPwd',{
                body: JSON.stringify(data)
            }).then((res) => {
                if (res.code === 200) {
                    this.$message.success('修改成功');
                    this.dialogResetPassword = false;
                } else {
                    this.$message.error('修改失败');
                }
            });
        },
        //复制
        async copyCode(item) {
            if (!item.teacher_code) {
                this.$message.error('请先生成参加码')
                return
            }
            try {
                // 等待用户授权
                await navigator.clipboard.writeText(item.teacher_code);
                this.$message.success('复制成功');
            } catch (err) {
                // 如果用户没有授权或者浏览器不支持Clipboard API
                alert('请手动复制参加码:' + item.teacher_code)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width:767px) and (max-width:1024px) {}

.el-container {
    height: 100%;
}

.el-header {
    background-color: #ffffff;

    .header-img {
        margin-left: 20px;
        height: 60px;
        display: flex;
        align-items: center;
    }
}

.el-main {
    .main-container {
        min-height: 100%;
        // height: 100%;
        background-color: #ffffff;

        .top-title {
            padding: 20px;
            font-size: 14px;
            font-weight: 500;
            position: relative;
        }

        .top-title::before {
            content: '';
            width: 2px;
            height: 15px;
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            background: #08C76B;
        }

        .top-notice {
            margin: -28px 20px 8px 20px;
            font-size: 12px;
            color: #909399;
            line-height: 1.45;
        }

        .course-list {
            margin: 10px 40px;

            .list-item {
                padding: 20px;
                border: 1px solid #E7E7E7;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;

                .right-box {
                    flex: 4;
                    display: flex;
                    flex-wrap: wrap;

                    .right-box-item {
                        margin: 5px;
                    }
                }

                .left-box {
                    flex: 2;
                    display: flex;
                    align-items: center;

                    .left-box-video-play {
                        font-size: 20px;
                        width: 40px;
                        height: 40px;
                        background-color: #08C76B;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 16px;
                            height: 16px;
                        }
                    }
                }

                .left-box-title {
                    margin-left: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    .left-box-top-title {
                        font-size: 14px;
                        font-weight: 500;
                    }

                    .teacher-class {
                        font-size: 12px;
                        font-weight: 400;
                        color: #808080;
                    }
                }
            }
        }
    }
}

.el-main {
    background: #F0F3F7;
}

.page-footer {
    background: #ffffff;
    border-top: 1px solid #ebeef5;
    padding: 0 20px;
}

.footer-inner {
    height: 60px;
    display: flex;
    align-items: center;
}

.footer-pagination {
    flex: 1;
    display: flex;
    align-items: center;
}

.footer-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    white-space: nowrap;

    span {
        margin-left: 10px;
        font-size: 14px;
        font-weight: 400;
    }
}

.container {
    height: 100%;
}

.detele-button {
    padding-bottom: 10px;
    display: inline-block;
}

.el-dropdown-link {
    color: #409EFF;
    display: flex;
    align-items: center;
}

:deep(.back-live-dialog) {
    max-width: 1600px;
    max-height: 80vh;
    height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

:deep(.back-live-dialog .el-dialog__body) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

:deep(.back-live-dialog .el-dialog__footer) {
    border-top: 1px solid #ebeef5;
    padding: 12px 20px;
}

.back-live-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.back-live-dialog-pagination {
    flex: 1;
    overflow: hidden;
}

.table-data {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
    margin-top: 8px;
}

.back-live-table {
    /* margin-top: 8px;  Moved margin to wrapper */
}

:deep(.back-live-dialog .back-live-table.el-table) {
    /* height: calc(80vh - 300px); Removed */
}

:deep(.back-live-dialog .back-live-table .el-table__body-wrapper) {
    /* Let Element UI handle overflow */
}

.mobile-user {
    display: none;
}
.mobile-label {
    display: none;
}

.mobile-list {
    display: none;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .pc-table {
        display: none;
    }
    .mobile-list {
        display: block;
        padding: 10px;
        background: #f5f7fa;
    }
    .mobile-card {
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
        margin-bottom: 15px;
        overflow: hidden;
    }
    .card-header {
        padding: 10px 15px;
        border-bottom: 1px solid #ebeef5;
        display: flex;
        align-items: center;
        background: #fafafa;
    }
    .card-title {
        margin-left: 10px;
        font-weight: bold;
        color: #303133;
        font-size: 14px;
        word-break: break-all;
    }
    .card-body {
        padding: 15px;
    }
    .card-row {
        margin-bottom: 8px;
        font-size: 13px;
        display: flex;
        align-items: flex-start;
    }
    .card-row:last-child {
        margin-bottom: 0;
    }
    .card-row .label {
        color: #909399;
        width: 70px;
        flex-shrink: 0;
    }
    .card-row .value {
        color: #606266;
        word-break: break-all;
    }
    .card-thumb {
        width: 100px;
        height: 56px;
        object-fit: cover;
        border-radius: 4px;
    }
    .card-footer {
        padding: 10px 15px;
        border-top: 1px solid #ebeef5;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
    
    .el-header {
        padding: 0 15px;
    }
    .back-live-dialog-footer {
        flex-direction: column;
        align-items: stretch;
        gap: 15px;
    }
    .back-live-dialog-pagination {
        width: 100%;
        display: flex;
        justify-content: center;
        overflow-x: auto;
    }
    .back-live-dialog-footer .el-button {
        width: 100%;
    }
    .el-header .header-img {
        margin-left: 0;
        height: 50px;
    }
    .mobile-user {
        display: block;
    }
    .pc-user {
        display: none;
    }
    .el-main .main-container .top-title {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 15px;
    }
    .el-main .main-container .course-list {
        margin: 10px;
    }
    .el-main .main-container .course-list .list-item {
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
    }
    .el-main .main-container .course-list .list-item .left-box {
        width: 100%;
        margin-bottom: 15px;
    }
    .el-main .main-container .course-list .list-item .right-box {
        width: 100%;
        justify-content: flex-start;
    }
    .el-main .main-container .course-list .list-item .right-box .right-box-item {
        margin: 5px 5px 5px 0;
    }
    .page-footer {
        padding: 10px;
    }
    .footer-inner {
        flex-direction: column;
        height: auto;
        gap: 10px;
        padding-bottom: 10px;
    }
    .footer-pagination {
        width: 100%;
        overflow-x: auto;
    }
    .footer-box {
        justify-content: center;
        width: 100%;
    }
    :deep(.el-pagination__sizes), :deep(.el-pagination__jump) {
        display: none !important;
    }
    :deep(.back-live-dialog) {
        width: 95% !important;
        margin-top: 5vh !important;
    }
    :deep(.el-dialog__body) {
        padding: 10px 15px;
    }
    .table-wrapper {
        overflow-x: hidden;
        margin-top: 0;
    }
}
</style>
